import { render, staticRenderFns } from "./afterDetailVoucher.vue?vue&type=template&id=6189127c&scoped=true&"
import script from "./afterDetailVoucher.vue?vue&type=script&lang=js&"
export * from "./afterDetailVoucher.vue?vue&type=script&lang=js&"
import style0 from "./afterDetailVoucher.vue?vue&type=style&index=0&id=6189127c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6189127c",
  null
  
)

export default component.exports